export default __webpack_public_path__ + "static/media/profit_pie.fbae6009.svg";